import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateEmailTemplateRPC } from "./updateEmailTemplateRPC";

export class UpdateEmailTemplateRPCClientImpl extends UpdateEmailTemplateRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateEmailTemplateRPC.Request): Promise<LeoRPCResult<UpdateEmailTemplateRPC.Response, UpdateEmailTemplateRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/UpdateEmailTemplate",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateEmailTemplateRPC.ResponseDTO,
      UpdateEmailTemplateRPC.Errors.ErrorsDTO,
      UpdateEmailTemplateRPC.Response,
      UpdateEmailTemplateRPC.Errors.Errors
    >(
      response,
      "email-cycle/UpdateEmailTemplate",
      UpdateEmailTemplateRPC.Response.fromDTO,
      UpdateEmailTemplateRPC.Errors.fromDTO
    );
  }
}
